
export interface IResponse<T> {
  data?: T | null;
  success: boolean;
  error?: string | null;
}

export interface IBdsApiService {
  validateToken(customerId: string, token: string): Promise<boolean>;
  submitQuestions(customerId: string, token: string, data: any): Promise<IResponse<any>>;
}

export class BdsApiService implements IBdsApiService {

  constructor(
    private readonly baseUri: string,
  ) {
  }

  public async validateToken(customerId: string, token: string): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseUri}/${customerId}/${token}`);
      if (response.status >= 400) {
        const error = await response.text();
        // @ts-ignore
        // console.log(error);
        return false;
      }
      const {result = false} = (await response.json()) || {};
      return !!result;
    } catch (err) {
      // @ts-ignore
      // console.log(err);
      return false;
    }
  }

  public async submitQuestions(customerId: string, token: string, data: any): Promise<IResponse<any>> {
    const body: any = {};

    Object.keys(data)
      .forEach((key) => {
        const value = data[key];
        if (Array.isArray(value) && value.length && value[0] || value) {
          body[key] = Array.isArray(value) ? value.join(',') : value;
        }
      });

    try {
      const response = await fetch(`${this.baseUri}/${customerId}/${token}`, {
        method: 'POST', body: JSON.stringify(body),
      });
      const {result = false} = (await response.json()) || {};
      if (result) {
        return {success: true};
      }

      throw result;
    } catch (e) {
      return {success: false, error: e.message};
    }
  }
}
